const MAX_CRYPTO_DECIMALS = 8

export function getCryptoCategoryLabel(category, isCredit = true) {
  switch (category) {
    case 'deposit':
      return 'Deposit'
    case 'withdraw':
      return 'Withdrawal'
    case 'swap':
      return 'Swap'
    case 'transfer':
      return isCredit ? 'Transfer received' : 'Transfer sent'
    case 'purchase':
      return 'Purchase'
    case 'sale':
      return 'Sale'
    default:
      return isCredit ? 'Credit' : 'Debit'
  }
}

export function getCryptoCategoryIcon(category, isCredit = true) {
  switch (category) {
    case 'deposit':
      return 'mdi-arrow-down'
    case 'withdraw':
      return 'mdi-arrow-up'
    case 'swap':
      return 'mdi-swap-horizontal'
    case 'transfer':
      return 'mdi-send'
    case 'purchase':
      return 'mdi-cart-outline'
    case 'sale':
      return 'mdi-cash'
    default:
      return isCredit ? 'mdi-arrow-down' : 'mdi-arrow-up'
  }
}

/**
 * Crypto amounts need far more precision than the fiat 2dp formatter, and
 * they must never reach the UI through the default Number stringification:
 * anything below 1e-6 comes out in scientific notation there, which is how a
 * balance rendered as "2.6e-7 doge". toLocaleString always writes plain
 * decimals.
 */
export function formatCryptoAmount(value) {
  const amount = Number(value || 0)
  if (!Number.isFinite(amount)) return '0.00'

  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: MAX_CRYPTO_DECIMALS
  })

  // Dust rounds away to "0.00" at 8dp, and a balance that reads as a flat
  // zero looks like an empty wallet rather than a tiny one.
  if (amount !== 0 && Number(formatted) === 0) {
    return `${amount < 0 ? '-' : ''}<0.00000001`
  }

  return formatted
}
